<template>
  <div class="surface-sample-information-widget">
    <div class="surface-sample-information-title">
      <h2>{{ $t('tableTitles.SurfaceSampleInfo') }}</h2>
    </div>
    <div class="surface-sample-information-widget-container">
      <surfaceSamplesTableOverview
        :enableCreateTableRowAction="enableCreateTableRowAction"
        :enableDeleteTableRowAction="enableDeleteTableRowAction"
        :enableUpdateTableRowAction="enableUpdateTableRowAction"
        :enableColumnChooser="enableColumnChooser"
        :searchPanelEnabled="searchPanelEnabled"
        :enableExportSettings="enableExportSettings"
      />
    </div>
  </div>
</template>
<script>
import surfaceSamplesTableOverview from '@/components/table-overviews/surfaceSamplesTableOverview'
export default {
  name: 'surfaceSampleInfoWidget',
  components: {
    surfaceSamplesTableOverview
  },
  data() {
    return {
      enableCreateTableRowAction: false,
      enableDeleteTableRowAction: false,
      enableUpdateTableRowAction: false,
      enableColumnChooser: false,
      searchPanelEnabled: false,
      enableExportSettings: false
    }
  }
}
</script>
<style lang="less" scoped>
.surface-sample-information-widget {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .surface-sample-information-title h2 {
    display: flex;
    justify-content: center;
    margin: 0 0 15px 0;
    font-size: 24px;
    padding-bottom: 15px;
    color: #89b368;
    border-bottom: 1px solid #d5d5d5;
  }
  .surface-sample-information-widget-container {
    display: flex;
    flex-direction: column;
    height: 85%;
    width: 100%;
  }
}
</style>
